import { render, staticRenderFns } from "./ItemImageUpdate.vue?vue&type=template&id=59a6bb44&"
import script from "./ItemImageUpdate.vue?vue&type=script&lang=js&"
export * from "./ItemImageUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports